import {
  Component,
  effect,
  inject,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
} from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { RouterOutlet } from "@angular/router";
import { FuseFullscreenComponent } from "@fuse/components/fullscreen";
import { FuseLoadingBarComponent } from "@fuse/components/loading-bar";
import {
  FuseNavigationService,
  FuseVerticalNavigationComponent,
} from "@fuse/components/navigation";
import { FuseMediaWatcherService } from "@fuse/services/media-watcher";
import { LanguagesComponent } from "app/core/components/layout/common/languages/languages.component";
import { MerchantSelectorComponent } from "app/core/components/layout/common/merchant-selector/merchant-selector.component";
import { UserComponent } from "app/core/components/layout/common/user/user.component";
import { IFuturisticMenu } from "app/core/models";
import { FolderService } from "app/core/services/folder.service";
import { NavigationService } from "app/core/services/navigation.service";
import { ThemeService } from "app/core/services/theme.service";
import { Subject, takeUntil } from "rxjs";

@Component({
  selector: "futuristic-layout",
  templateUrl: "./futuristic.component.html",
  styleUrls: ["./futuristic.component.scss"],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    FuseVerticalNavigationComponent,
    FuseLoadingBarComponent,
    FuseFullscreenComponent,
    MatButtonModule,
    UserComponent,
    MerchantSelectorComponent,
    LanguagesComponent,
    MatIconModule,
    RouterOutlet,
  ],
})
export class FuturisticLayoutComponent implements OnInit, OnDestroy {
  private _fuseMediaWatcherService = inject(FuseMediaWatcherService);
  private _fuseNavigationService = inject(FuseNavigationService);
  private _navigationService = inject(NavigationService);
  private _folderService = inject(FolderService);
  private _themeService = inject(ThemeService);

  private _unsubscribeAll: Subject<any> = new Subject<any>();

  logoUrl = "";
  isScreenSmall: boolean = false;
  isDarkTheme: boolean = false;
  navigation: IFuturisticMenu = { futuristic: [] };

  public navigationEffect = effect(() => {
    this.navigation = this._navigationService.menu();
  });

  public effectTheme = effect(() => {
    this.isDarkTheme = this._themeService.isDarkTheme();
  });

  get currentYear(): number {
    return new Date().getFullYear();
  }

  ngOnInit(): void {
    this.logoUrl = this.getLogoURL();

    this._fuseMediaWatcherService.onMediaChange$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe(({ matchingAliases }) => {
        this.isScreenSmall = !matchingAliases.includes("md");
      });
  }

  getLogoURL() {
    const folderScope = this._folderService.folder();
    return `images/logos/${folderScope}/logo-web-white.png`;
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

  /**
   * Toggle navigation
   *
   * @param name
   */
  toggleNavigation(name: string): void {
    const navigation = this._fuseNavigationService.getComponent<
      FuseVerticalNavigationComponent
    >(name);

    if (navigation) {
      navigation.toggle();
    }
  }

  toggleTheme() {
    this._themeService.handleToggleTheme();
  }
}
